import { AlertCircle } from 'lucide-react';
import type { StaleReason } from '../lib/staleness';
import { STALE_REASON_LABELS } from '../lib/staleness';

// =============================================================================
// NeedsReviewFlag (v0.2.38)
//
// A small "Needs review" pill shown on a scholarship card when staleness.ts
// flags it. The hover title lists the specific reasons. Kept visually distinct
// from the v0.2.31 computed badges — this is an action prompt, not a label.
// =============================================================================

export function NeedsReviewFlag({ reasons }: { reasons: StaleReason[] }) {
  if (reasons.length === 0) return null;
  const detail = reasons.map((r) => STALE_REASON_LABELS[r]).join(' \u2022 ');
  return (
    <span
      className="inline-flex items-center gap-1 rounded bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800"
      title={detail}
    >
      <AlertCircle size={12} />
      Needs review
    </span>
  );
}

/** The same reasons rendered as a short inline list (for a detail context). */
export function NeedsReviewReasons({ reasons }: { reasons: StaleReason[] }) {
  if (reasons.length === 0) return null;
  return (
    <ul className="mt-1 space-y-0.5">
      {reasons.map((r) => (
        <li key={r} className="flex items-start gap-1.5 text-xs text-amber-800">
          <AlertCircle size={12} className="mt-0.5 shrink-0" />
          {STALE_REASON_LABELS[r]}
        </li>
      ))}
    </ul>
  );
}
